import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { api, errMsg } from "@/lib/api";

export function PasswordDialog({ open, onOpenChange }) {
  const [f, setF] = useState({ current_password: "", new_password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/change-password", f);
      toast.success("Password aggiornata");
      setF({ current_password: "", new_password: "" });
      onOpenChange(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="password-dialog">
        <DialogHeader><DialogTitle>Cambia password</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Password attuale">
            <Input type="password" required value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="current-password-input" />
          </Field>
          <Field label="Nuova password" hint="Almeno 8 caratteri">
            <Input type="password" required minLength={8} value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="new-password-input" />
          </Field>
          <DialogFooter><Button type="submit" disabled={busy} data-testid="password-submit-btn">Salva</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
